import { JcSize, JcUtils } from '../../utils/JcUtils';
import { JcButton, JcButtonProps, JcButtonType } from './JcButton';
import { JcBuiltInIconProps, JcCustomIconProps, JcIcon } from '../icon/JcIcon';

import React, { forwardRef } from 'react';


export interface JcIconButtonProps extends Omit<JcButtonProps, "children" | "buttonType" | "size"> {
  iconProps: Omit<JcCustomIconProps, "size"> | Omit<JcBuiltInIconProps, "size">;
  readonly size?: JcSize;
}

export const JcIconButton = forwardRef((props: JcIconButtonProps, ref: React.ForwardedRef<HTMLButtonElement>): React.ReactElement => {
  const { iconProps, size = JcSize.SMALL, ...otherProps } = props;

  const commonProps = JcUtils.commonProps(otherProps, [
    "jc-icon-button",
    size !== JcSize.NONE && ("jc-icon-button-size-" + size),
  ]);
  const buttonProps = JcUtils.otherProps(otherProps)

  return <JcButton ref={ref} {...buttonProps} {...commonProps} buttonType={JcButtonType.GHOST}>
    <JcIcon {...iconProps} size={JcSize.NONE} />
  </JcButton>
})
